export default __webpack_public_path__ + "static/media/right-blue-arrow.80aedbd2.svg";